export default __webpack_public_path__ + "media/images/home/corporate/sm-85e906f84185382bed1a095b090828dd.webp";